module.exports = __webpack_public_path__ + "img/woman_child_back.f30198c7.png";